import React, { ReactNode } from 'react';

import SubmitModal, { Props as SubmitModalProps } from './SubmitModal';

export type Props = {
    message: ReactNode;
} & SubmitModalProps;

const AlertModal: React.FC<Props> = (props: Props) => {
    const { message, ...restProps } = props;

    return (
        <SubmitModal isCancelEnabled={false} {...restProps}>
            {message}
        </SubmitModal>
    );
};

export default AlertModal;
